export interface BatchDeltasColDef {
  flex: number;
  minWidth: number;
  cellDataType: string;
  field: string;
  headerName: string;
  sortable?: boolean;
  lockPosition?: string;
  checkboxSelection?: boolean;
  filter?: string;
  valueGetter?: (params: any) => any;
  filterPath?: string; // Used for server-side filtering
  filterParams?: {
    maxNumConditions?: number;
    [key: string]: any;
  };
  cellRenderer?: string; // For custom cell renderers
}

export const BatchDeltasColDefs: BatchDeltasColDef[] = [
  // { field: 'checkbox', width: 105, lockPosition: 'left', cellDataType: 'string', headerName: '', checkboxSelection: true },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'TitleInternalAlias',
    headerName: 'Title Internal Alias',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Meta?.Title || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Meta__Title'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'ALID',
    headerName: 'ALID',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.ALID || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'ALID'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'WorkType',
    headerName: 'Work Type',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Asset?.WorkType || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Asset__WorkType'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'LicenseType',
    headerName: 'License Type',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Transaction?.LicenseType || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Transaction__LicenseType'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'Territory',
    headerName: 'Territory',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Transaction?.Territory?.country || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Transaction__Territory__country'
  },
  {
    flex: 1,
    minWidth: 150,
    cellDataType: 'string',
    field: 'Transmission Status',
    headerName: 'Transmission Status',
    sortable: false,
    valueGetter: (params) => {
      return params.data?.primeTransmissionStatus?.statusCode || '';
    },
    filter: 'transmissionStatusFilter',
    filterPath: 'primeTransmissionStatus__statusCode',
    cellRenderer: 'TransmissionStatusCellRendererComponent'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'FormatProfile',
    headerName: 'Format Profile',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Transaction?.FormatProfile?.value || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Transaction__FormatProfile__value'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'AllowedLanguage',
    headerName: 'Allowed Language',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.Transaction?.AllowedLanguage || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'Transaction__AllowedLanguage'
  },

  // DATE COLUMNS : Equals, Does not equal, Before, After, Between
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'date',
    field: 'Start',
    headerName: 'Start',
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: {
      browserDatePicker: true,
      minValidYear: 2000,
      maxValidYear: 2099,
      filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'inRange']
    },
    valueGetter: (params) => {
      return params.data?.Transaction?.Start || '';
    },
    filterPath: 'Transaction__Start'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'date',
    field: 'End',
    headerName: 'End',
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: {
      browserDatePicker: true,
      filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'inRange']
    },
    valueGetter: (params) => {
      return params.data?.Transaction?.End || '';
    },
    filterPath: 'Transaction__End'
  },

  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'MoneyValue',
    headerName: 'Value',
    sortable: false,
    valueGetter: (params) => {
      const terms = params.data?.Transaction?.Terms || [];
      const wspTerm = terms.find((term: any) => term._termName === 'WSP');
      return wspTerm?.Money?.value || '';
    },
    filterParams: {
      filterOptions: ['equals', 'notEqual', 'blank', 'notBlank'],
    },
    filterPath: 'Terms__WSP__Money__value'
  },
  {
    flex: 1,
    minWidth: 50,
    cellDataType: 'string',
    field: 'MoneyCurrency',
    headerName: 'Currency',
    sortable: false,
    valueGetter: (params) => {
      const terms = params.data?.Transaction?.Terms || [];
      const wspTerm = terms.find((term: any) => term._termName === 'WSP');
      return wspTerm?.Money?._currency || '';
    },
    filterParams: {
      filterOptions: ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith', 'blank', 'notBlank'],
    },
    filterPath: 'Terms__WSP__Money___currency'
  },
];
